import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Revisione53State, STATE_KEY_REVISIONE53 } from '../revisione53.reducers';
import { Utilities } from '@core/helpers/utilities';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty, isNilOrEmptyOrZero, toBoolean } from '@shared/helpers/utils.helper';
import { AderentiAEnum } from '@shared/constants/aderenti-a.enum';

const revisione53State = createFeatureSelector<Revisione53State>(STATE_KEY_REVISIONE53);

export abstract class revisione53DatiFormSelectors {
    static getCkAltreCoopAllegaSchedaTrasporto = createSelector(
        revisione53State,
        (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop.my_CkAltreCoopAllegaSchedaTrasporto
    );

    static aderenteDalConf = createSelector(revisione53State, (state) => {
        const my_ElAderentiA = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_AderentiA.my_ElAderentiA ?? [];
        const confElement = my_ElAderentiA.find((e) => e.my_SezVisibAderenteA?.my_AderenteA?.toUpperCase() === AderentiAEnum.confcooperative.toString());
        return confElement?.my_SezVisibAderenteA?.my_aderenteDal ?? null;
    });

    static getScTrasportoObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopTrasporto.my_ScTrasportoObbl);

    static getScSocObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_ScSocObbl);

    static getScCoopDettagliObbl = createSelector(
        revisione53State,
        (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopDettaglianti.my_ScCoopDettagliObbl
    );

    static getScPDLObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopPDL.my_ScPDLObbl);

    static getScConsumoObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopConsumo.my_ScConsumoObbl);

    static getScCoopFidiObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopFidi.my_ScCoopFidiObbl);

    static getScPescaObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopPesca.my_ScPescaObbl);

    static getScEdilObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopEdil.my_ScEdilObbl);

    static getScAltreCoopObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop.my_ScAltreCoopObbl);

    static getScAgricoleObbl = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopAgricole.my_ScAgricoleObbl);

    static getMy_TipoSezEnte = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte);

    static getCkNorme = createSelector(revisione53State, (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_CkNorme);

    static getCkAltreCoopAllegaSchedaPDL = createSelector(
        revisione53State,
        (state) => state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop.my_CkAltreCoopAllegaSchedaPDL
    );

    static getDisablingConditionFromSociSpecData = createSelector(revisione53State, (state) => {
        const my_SociSpecData = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_SociSpecData;
        return isNilOrEmpty(my_SociSpecData) || toNum(my_SociSpecData) <= 0;
    });

    static isNotCkNormeSocioLavoratOne = createSelector(revisione53State, (state) => {
        const my_CkNormeSocioLavorat = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkNormeSocioLavorat;
        return toNum(my_CkNormeSocioLavorat) !== 1;
    });

    static isNotCkRedazRegolamOne = createSelector(revisione53State, (state) => {
        const my_CkRedazRegolam = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkRedazRegolam;
        return toNum(my_CkRedazRegolam) !== 1;
    });

    static isNotCkRegolamentoConformeZero = createSelector(revisione53State, (state) => {
        const my_CkRegolamentoConforme = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_gruppo20.my_CkRegolamentoConforme;
        return toNum(my_CkRegolamentoConforme) !== 0;
    });

    static isNotCkScopoMutualOne = createSelector(revisione53State, (state) => {
        const my_CkScopoMutual = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkScopoMutual;
        return toNum(my_CkScopoMutual) !== 1;
    });

    static isNotCkScopoMutualZero = createSelector(revisione53State, (state) => {
        const my_CkScopoMutual = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkScopoMutual;
        return toNum(my_CkScopoMutual) !== 0;
    });

    static isNotRegolamInterniOne = createSelector(revisione53State, (state) => {
        const my_CkRegolamInterni = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRegolamInterni;
        return toNum(my_CkRegolamInterni) !== 1;
    });

    static isNotCkCondizPrevNotaIntegrZero = createSelector(revisione53State, (state) => {
        const my_CkCondizPrevNotaIntegr = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkCondizPrevNotaIntegr;
        return toNum(my_CkCondizPrevNotaIntegr) !== 0;
    });

    static isNotCkSocLavSubOne = createSelector(revisione53State, (state) => {
        const my_CkSocLavSub = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSub;
        return toNum(toBoolean(my_CkSocLavSub)) !== 1;
    });

    static isNotCkSocLavSubTempoDeterminatoOne = createSelector(revisione53State, (state) => {
        const my_CkSocLavSubTempoDeterminato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSubTempoDeterminato;
        return toNum(toBoolean(my_CkSocLavSubTempoDeterminato)) !== 1;
    });

    static isNotCkSocLavParaSubOne = createSelector(revisione53State, (state) => {
        const my_CkSocLavParaSub = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavParaSub;
        return toNum(toBoolean(my_CkSocLavParaSub)) !== 1;
    });

    static isNotCkSocLavAutOne = createSelector(revisione53State, (state) => {
        const my_CkSocLavAut = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavAut;
        return toNum(toBoolean(my_CkSocLavAut)) !== 1;
    });

    static isNotCkSocLavAltroOne = createSelector(revisione53State, (state) => {
        const my_CkSocLavAltro = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavAltro;
        return toNum(toBoolean(my_CkSocLavAltro)) !== 1;
    });

    static isNotCkTipiRappLavCorrettiZero = createSelector(revisione53State, (state) => {
        const my_CkTipiRappLavCorretti = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkTipiRappLavCorretti;
        return toNum(my_CkTipiRappLavCorretti) !== 0;
    });

    static isCkContrattoCollLavSubToHide = createSelector(revisione53State, (state) => {
        const my_CkNormeSocioLavorat = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkNormeSocioLavorat;
        const my_CkRedazRegolam = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkRedazRegolam;
        const my_CkSocLavSub = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSub;
        const my_CkSocLavSubTempoDeterminato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSubTempoDeterminato;
        // InfoPath (sec22bis): hidden only when both subordinate-work checks are explicitly "0" (empty keeps it visible).
        return toNum(my_CkNormeSocioLavorat) !== 1 || toNum(my_CkRedazRegolam) !== 1 || (toNum(my_CkSocLavSub) === 0 && toNum(my_CkSocLavSubTempoDeterminato) === 0);
    });

    static isNotTipoSezEnteTwoOrFive = createSelector(revisione53State, (state) => {
        const my_TipoSezEnte = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte;
        return toNum(my_TipoSezEnte) !== 2 && toNum(my_TipoSezEnte) !== 5;
    });

    static isCkAttivFacchinToHide = createSelector(revisione53State, (state) => {
        const my_ckAttivFacchin = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_gruppo13.my_ckAttivFacchin;
        const my_TipoSezEnte = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte;
        return toNum(my_ckAttivFacchin) !== 1 || (toNum(my_TipoSezEnte) !== 2 && toNum(my_TipoSezEnte) !== 5);
    });

    static isDescContrSocLavNoConfToHide = createSelector(revisione53State, (state) => {
        const my_CkNormeSocioLavorat = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkNormeSocioLavorat;
        const my_CkContrApplicConforme = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_gruppo11.my_CkContrApplicConforme;
        return toNum(my_CkNormeSocioLavorat) !== 1 || toNum(my_CkContrApplicConforme) === 1;
    });

    static isDescRuoloSocNoAttSocToHide = createSelector(revisione53State, (state) => {
        const my_CkNormeSocioLavorat = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkNormeSocioLavorat;
        const my_ckSoggLibrSociNoAttSociali = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_gruppo17.my_ckSoggLibrSociNoAttSociali;
        return toNum(my_CkNormeSocioLavorat) !== 1 || toNum(my_ckSoggLibrSociNoAttSociali) === 0;
    });

    static isTabellaContrattiAdottatiToHide = createSelector(revisione53State, (state) => {
        const my_CkNormeSocioLavorat = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkNormeSocioLavorat;
        const my_CkRedazRegolam = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkRedazRegolam;
        const my_CkContrattoCollLavSub = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkContrattoCollLavSub;
        const my_CkSocLavSub = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSub;
        const my_CkSocLavSubTempoDeterminato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_CkSocLavSubTempoDeterminato;
        return (
            toNum(my_CkContrattoCollLavSub) !== 1 ||
            toNum(my_CkNormeSocioLavorat) !== 1 ||
            toNum(my_CkRedazRegolam) !== 1 ||
            (toNum(my_CkSocLavSub) !== 1 && toNum(my_CkSocLavSubTempoDeterminato) !== 1)
        );
    });

    static isDBPresente = createSelector(revisione53State, (state) => {
        const my_DBPresente = state.revisione?.dati.my_Verbale.my_DBPresente;
        return toNum(my_DBPresente) === 1;
    });

    static isNotDBPresente = createSelector(revisione53State, (state) => {
        const my_DBPresente = state.revisione?.dati.my_Verbale.my_DBPresente;
        return toNum(my_DBPresente) === 0;
    });

    static isNotAttPrevalSociZero = createSelector(revisione53State, (state) => {
        const my_CkAttPrevalSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkAttPrevalSoci;
        return toNum(my_CkAttPrevalSoci) !== 0;
    });

    static isRegimeDerogatorioProvalenzaToHide = createSelector(revisione53State, (state) => {
        const my_DBPresente = state.revisione?.dati.my_Verbale.my_DBPresente;
        const my_CkAttPrevalSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkAttPrevalSoci;
        const my_CkRientraRegDerogatori = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRientraRegDerogatori;
        return toNum(my_DBPresente) === 0 || toNum(my_CkAttPrevalSoci) !== 0 || toNum(my_CkRientraRegDerogatori) !== 1;
    });

    static isEsisteRipDividSociMutNPToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2;
    });

    static isRipDividSociMutNPToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        const my_CkEsisteRipDividSociMutNP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkEsisteRipDividSociMutNP;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2 || toNum(my_CkEsisteRipDividSociMutNP) === 0;
    });

    static isCostituiteRiserveDivisibiliToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2;
    });

    static IscrizAlboAndCostituiteRiserveDivisibiliCondition = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        const my_CkCostituiteRiserveDivisibili = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkCostituiteRiserveDivisibili;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2 || toNum(my_CkCostituiteRiserveDivisibili) !== 1;
    });

    static isRiserveDivisibiliRispetPrevisionToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        const my_CkCostituiteRiserveDivisibili = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkCostituiteRiserveDivisibili;
        const my_CkRiserveDivisibiliRipartite = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRiserveDivisibiliRipartite;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2 || toNum(my_CkCostituiteRiserveDivisibili) !== 1 || toNum(my_CkRiserveDivisibiliRipartite) !== 1;
    });

    static isMutualitaNonPrevalenteToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        return toNum(my_CkIscrizAlboCoopMutP) !== 2;
    });

    static isMutualitaPrevalenteToHide = createSelector(revisione53State, (state) => {
        const my_CkIscrizAlboCoopMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkIscrizAlboCoopMutP;
        return toNum(my_CkIscrizAlboCoopMutP) !== 1 && toNum(my_CkIscrizAlboCoopMutP) !== 4;
    });

    static isNotSonoStatiRipDividSociMutOne = createSelector(revisione53State, (state) => {
        const my_CkSonoStatiRipDividSociMutP = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkSonoStatiRipDividSociMutP;
        return toNum(my_CkSonoStatiRipDividSociMutP) !== 1;
    });

    static isNotEmessoStrumFinanziariOne = createSelector(revisione53State, (state) => {
        const my_CkEmessoStrumFinanziari = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkEmessoStrumFinanziari;
        return toNum(my_CkEmessoStrumFinanziari) !== 1;
    });

    static isRispettoGestStrumFinanziariToHide = createSelector(revisione53State, (state) => {
        const my_CkEmessoStrumFinanziari = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkEmessoStrumFinanziari;
        const my_CkRemuneratiStrumFinanziari = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRemuneratiStrumFinanziari;
        return toNum(my_CkEmessoStrumFinanziari) !== 1 || toNum(my_CkRemuneratiStrumFinanziari) !== 1;
    });

    static isCambiatoSezioneZero = createSelector(revisione53State, (state) => {
        const my_CkCambiatoSezione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkCambiatoSezione;
        return toNum(my_CkCambiatoSezione) === 0;
    });

    static my_CkOffreBeniServ = createSelector(revisione53State, (state) => {
        const my_CkOffreBeniServ = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreBeniServ;
        return toNum(my_CkOffreBeniServ);
    });

    static my_CkOffreOccLavSoci = createSelector(revisione53State, (state) => {
        const my_CkOffreOccLavSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreOccLavSoci;
        return toNum(my_CkOffreOccLavSoci);
    });

    static my_CkRemunConferProdSoci = createSelector(revisione53State, (state) => {
        const my_CkRemunConferProdSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRemunConferProdSoci;
        return toNum(my_CkRemunConferProdSoci);
    });

    static my_CkRemunPrestConfServSoci = createSelector(revisione53State, (state) => {
        const my_CkRemunPrestConfServSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkRemunPrestConfServSoci;
        return toNum(my_CkRemunPrestConfServSoci);
    });

    static my_BilAnno1 = createSelector(revisione53State, (state) => {
        const my_BilAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno1;
        return toNum(my_BilAnno1);
    });

    static my_BilAnno2 = createSelector(revisione53State, (state) => {
        const my_BilAnno2 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno2;
        return toNum(my_BilAnno2);
    });

    static my_BilAnno1DisablingCondition = createSelector(revisione53State, (state) => {
        const my_BilancioAllegato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_BilAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno1;
        return isNilOrEmpty(my_BilancioAllegato) || isNilOrEmpty(my_BilAnno1);
    });

    static my_BilAnno2DisablingCondition = createSelector(revisione53State, (state) => {
        const my_BilancioAllegato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        const my_BilAnno2 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiBilancio.my_BilAnno2;
        return isNilOrEmpty(my_BilancioAllegato) || isNilOrEmpty(my_BilAnno2);
    });

    static isCoopInattivaCommPrimoAnnoToHide = createSelector(revisione53State, (state) => {
        const my_CkOffreBeniServCoopAttPrimoAnno =
            state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkOffreBeniServCoopAttPrimoAnno;
        const my_CkOffreOccLavSociCoopAttPrimoAnno =
            state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkOffreOccLavSociCoopAttPrimoAnno;
        const my_CkRemunConferProdSociCoopAttPrimoAnno =
            state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkRemunConferProdSociCoopAttPrimoAnno;
        const my_CkRemunPrestConfServSociCoopAttPrimoAnno =
            state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkRemunPrestConfServSociCoopAttPrimoAnno;
        const my_TotaleA1NonModifPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1NonModifPrimoAnno;
        return !(
            toNum(my_TotaleA1NonModifPrimoAnno) > 0 &&
            toNum(my_CkOffreBeniServCoopAttPrimoAnno) === 0 &&
            toNum(my_CkOffreOccLavSociCoopAttPrimoAnno) === 0 &&
            toNum(my_CkRemunConferProdSociCoopAttPrimoAnno) === 0 &&
            toNum(my_CkRemunPrestConfServSociCoopAttPrimoAnno) === 0
        );
    });

    static isCoopInattivaCommToHide = createSelector(revisione53State, (state) => {
        const my_CkOffreBeniServCoopAtt = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkOffreBeniServCoopAtt;
        const my_CkOffreOccLavSociCoopAtt = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkOffreOccLavSociCoopAtt;
        const my_CkRemunConferProdSociCoopAtt = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkRemunConferProdSociCoopAtt;
        const my_CkRemunPrestConfServSociCoopAtt =
            state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkRemunPrestConfServSociCoopAtt;
        const my_TotaleA1NonModif = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1NonModif;
        return !(
            toNum(my_TotaleA1NonModif) > 0 &&
            toNum(my_CkOffreBeniServCoopAtt) === 0 &&
            toNum(my_CkOffreOccLavSociCoopAtt) === 0 &&
            toNum(my_CkRemunConferProdSociCoopAtt) === 0 &&
            toNum(my_CkRemunPrestConfServSociCoopAtt) === 0
        );
    });

    static isBilancioAllegatoEmpty = createSelector(revisione53State, (state) => {
        const my_BilancioAllegato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        return isNilOrEmpty(my_BilancioAllegato);
    });

    static isCkValoreQuantitaQ = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantita = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantita;
        return my_CkValoreQuantita === 'Q';
    });

    static isCkValoreQuantitaV = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantita = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantita;
        return my_CkValoreQuantita === 'V';
    });

    static isCkValoreQuantitaPrimoAnnoQ = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantitaPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantitaPrimoAnno;
        return my_CkValoreQuantitaPrimoAnno === 'Q';
    });

    static isCkValoreQuantitaPrimoAnnoV = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantitaPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantitaPrimoAnno;
        return my_CkValoreQuantitaPrimoAnno === 'V';
    });

    static isOffreBeniServCommPrimoAnnoToHide = createSelector(revisione53State, (state) => {
        const my_CkOffreBeniServ = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_CkOffreBeniServ;
        const my_A1versoSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSociPrimoAnno;
        const my_TotaleA1PrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1PrimoAnno;
        const my_TotaleA1NonModifPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1NonModifPrimoAnno;
        return (
            toNum(my_CkOffreBeniServ) !== 1 ||
            toNum(my_A1versoSociPrimoAnno) !== 0 ||
            toNum(my_TotaleA1PrimoAnno) !== 0 ||
            isNilOrEmpty(my_TotaleA1NonModifPrimoAnno) ||
            toNum(my_TotaleA1NonModifPrimoAnno) === 0
        );
    });
    static isOffreBeniServCommToHide = createSelector(revisione53State, (state) => {
        const my_A1versoSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci;
        const my_TotaleA1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1;
        const my_TotaleA1NonModif = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleA1NonModif;
        return toNum(my_A1versoSoci) !== 0 || toNum(my_TotaleA1) !== 0 || isNilOrEmpty(my_TotaleA1NonModif) || toNum(my_TotaleA1NonModif) === 0;
    });
    static isOffreOccLavSociCommPrimoAnnoToHide = createSelector(revisione53State, (state) => {
        const my_B9versoSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B9versoSociPrimoAnno;
        const my_TotaleB9PrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB9PrimoAnno;
        const my_TotaleB9NonModifPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB9NonModifPrimoAnno;
        return toNum(my_B9versoSociPrimoAnno) !== 0 || toNum(my_TotaleB9PrimoAnno) !== 0 || isNilOrEmpty(my_TotaleB9NonModifPrimoAnno) || toNum(my_TotaleB9NonModifPrimoAnno) === 0;
    });
    static isOffreOccLavSociCommToHide = createSelector(revisione53State, (state) => {
        const my_B9versoSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B9versoSoci;
        const my_TotaleB9 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB9;
        const my_TotaleB9NonModif = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB9NonModif;
        return toNum(my_B9versoSoci) !== 0 || toNum(my_TotaleB9) !== 0 || isNilOrEmpty(my_TotaleB9NonModif) || toNum(my_TotaleB9NonModif) === 0;
    });
    static isRemunConferProdSociCommPrimoAnnoToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantitaPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantitaPrimoAnno;
        const my_B6confSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B6confSociPrimoAnno;
        const my_TotaleB6PrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB6PrimoAnno;
        const my_TotaleB6NonModifPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB6NonModifPrimoAnno;
        const my_QtaConfSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_QtaConfSociPrimoAnno;
        const my_TotQtaConfSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotQtaConfSociPrimoAnno;
        return !(
            (my_CkValoreQuantitaPrimoAnno === 'V' && toNum(my_B6confSociPrimoAnno) === 0 && toNum(my_TotaleB6PrimoAnno) === 0 && toNum(my_TotaleB6NonModifPrimoAnno) > 0) ||
            (my_CkValoreQuantitaPrimoAnno === 'Q' && toNum(my_QtaConfSociPrimoAnno) === 0 && toNum(my_TotQtaConfSociPrimoAnno) === 0 && toNum(my_TotaleB6NonModifPrimoAnno) > 0)
        );
    });
    static isRemunConferProdSociCommToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantita = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantita;
        const my_B6confSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B6confSoci;
        const my_TotaleB6 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB6;
        const my_TotaleB6NonModif = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB6NonModif;
        const my_QtaConfSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_QtaConfSoci;
        const my_TotQtaConfSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotQtaConfSoci;
        return !(
            (my_CkValoreQuantita === 'V' && toNum(my_B6confSoci) === 0 && toNum(my_TotaleB6) === 0 && toNum(my_TotaleB6NonModif) > 0) ||
            (my_CkValoreQuantita === 'Q' && toNum(my_QtaConfSoci) === 0 && toNum(my_TotQtaConfSoci) === 0 && toNum(my_TotaleB6NonModif) > 0)
        );
    });
    static isRemunPrestConfServSociCommPrimoAnnoToHide = createSelector(revisione53State, (state) => {
        const my_B7ricevSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B7ricevSociPrimoAnno;
        const my_TotaleB7PrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB7PrimoAnno;
        const my_TotaleB7NonModifPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB7NonModifPrimoAnno;
        return toNum(my_B7ricevSociPrimoAnno) !== 0 || toNum(my_TotaleB7PrimoAnno) !== 0 || isNilOrEmpty(my_TotaleB7NonModifPrimoAnno) || toNum(my_TotaleB7NonModifPrimoAnno) === 0;
    });
    static isRemunPrestConfServSociCommToHide = createSelector(revisione53State, (state) => {
        const my_B7ricevSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B7ricevSoci;
        const my_TotaleB7 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB7;
        const my_TotaleB7NonModif = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_TotaleB7NonModif;
        return toNum(my_B7ricevSoci) !== 0 || toNum(my_TotaleB7) !== 0 || isNilOrEmpty(my_TotaleB7NonModif) || toNum(my_TotaleB7NonModif) === 0;
    });

    static isBilAnno1ResultQToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantitaPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantitaPrimoAnno;
        const my_A1versoSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSociPrimoAnno;
        const my_B9versoSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B9versoSociPrimoAnno;
        const my_B7ricevSociPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B7ricevSociPrimoAnno;
        return my_CkValoreQuantitaPrimoAnno !== 'Q' || (isNilOrEmpty(my_A1versoSociPrimoAnno) && isNilOrEmpty(my_B9versoSociPrimoAnno) && isNilOrEmpty(my_B7ricevSociPrimoAnno));
    });

    static isBilAnno1ResultNOTQToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantitaPrimoAnno = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantitaPrimoAnno;
        return my_CkValoreQuantitaPrimoAnno === 'Q';
    });

    static isBilAnno2ResultQToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantita = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantita;
        const my_A1versoSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSoci;
        const my_B9versoSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B9versoSoci;
        const my_B7ricevSoci = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_B7ricevSoci;
        return my_CkValoreQuantita !== 'Q' || (isNilOrEmpty(my_A1versoSoci) && isNilOrEmpty(my_B9versoSoci) && isNilOrEmpty(my_B7ricevSoci));
    });

    static isBilAnno2ResultNOTQToHide = createSelector(revisione53State, (state) => {
        const my_CkValoreQuantita = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_CkValoreQuantita;
        return my_CkValoreQuantita === 'Q';
    });

    static isAllegareBilancioWarningToHide = createSelector(revisione53State, (state) => {
        const my_BilancioAllegato = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_Bilancio.my_BilancioAllegato;
        return !isNilOrEmpty(my_BilancioAllegato);
    });

    static isSezEnteToHide = createSelector(revisione53State, (state) => {
        const my_CkMutualPrev = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkMutualPrev;
        const my_DBPresente = state.revisione?.dati.my_Verbale.my_DBPresente;
        return toNum(my_DBPresente) === 0 || (toNum(my_CkMutualPrev) !== 1 && toNum(my_CkMutualPrev) !== 2 && toNum(my_CkMutualPrev) !== 4);
    });

    static isEsitoUltimaRevisioneToHide = createSelector(revisione53State, (state) => {
        const my_id_esito_ultima_revisione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_id_esito_ultima_revisione;
        return isNilOrEmpty(my_id_esito_ultima_revisione) || toNum(my_id_esito_ultima_revisione) === 0 || toNum(my_id_esito_ultima_revisione) === 100;
    });

    static isModoDiAssociazioneToHide = createSelector(revisione53State, (state) => {
        const my_TipoSezEnte = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte;
        const my_CkAltreCoopAllegaSchedaTrasporto = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop.my_CkAltreCoopAllegaSchedaTrasporto;
        return toNum(my_TipoSezEnte) !== 8 && toNum(my_TipoSezEnte) !== 10 && toNum(my_CkAltreCoopAllegaSchedaTrasporto) !== 1;
    });

    static my_CkMutualPrev = createSelector(revisione53State, (state) => {
        const my_CkMutualPrev = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_CkMutualPrev;
        return toNum(my_CkMutualPrev);
    });

    static isCkSrlAssembDetCompAmminToHide = createSelector(revisione53State, (state) => {
        const my_CkNorme = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_CkNorme;
        const my_CkSrlGratuitaCariche = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlGratuitaCariche;
        return toNum(my_CkNorme) !== 1 || toNum(my_CkSrlGratuitaCariche) !== 0;
    });

    static isCkSrlAssembDetCompSindaciToHide = createSelector(revisione53State, (state) => {
        const my_CkNorme = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_CkNorme;
        const my_CkSrlGratuitaCariche = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlGratuitaCariche;
        const my_CkSrlAssembNominSind = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlAssembNominSind;
        return toNum(my_CkNorme) !== 1 || toNum(my_CkSrlGratuitaCariche) !== 0 || isNilOrEmptyOrZero(my_CkSrlAssembNominSind);
    });

    static isConsiglioAmministrazioneToHide = createSelector(revisione53State, (state) => {
        const my_CkSrlTipoAmministrazione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione;
        const my_AllElemConsiglioAmministrazione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione;
        return toNum(my_CkSrlTipoAmministrazione) !== 1 && isNilOrEmpty(my_AllElemConsiglioAmministrazione);
    });

    static isAmministratoreUnicoToHide = createSelector(revisione53State, (state) => {
        const my_CkSrlTipoAmministrazione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione;
        const my_AllAmminUnico = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllAmminUnico;
        return toNum(my_CkSrlTipoAmministrazione) !== 2 && isNilOrEmpty(my_AllAmminUnico);
    });

    static isLiquidatoriToHide = createSelector(revisione53State, (state) => {
        const my_CkSrlTipoAmministrazione = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_NormeSrl.my_CkSrlTipoAmministrazione;
        const my_AllElemLiquidatori = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllLiquidatori.my_AllElemLiquidatori;
        return toNum(my_CkSrlTipoAmministrazione) !== 3 && isNilOrEmpty(my_AllElemLiquidatori);
    });

    static getQuozPrimStrutturaA2 = createSelector(revisione53State, (state) => {
        const my_PatrimNetto = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_PatrimNetto;
        const my_Immobilizzazioni = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_Immobilizzazioni;
        return Utilities.safeDivide(my_PatrimNetto, my_Immobilizzazioni);
    });

    static getQuozPrimStrutturaA1 = createSelector(revisione53State, (state) => {
        const my_PatrimNettoAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_PatrimNettoAnno1;
        const my_ImmobilizzazioniAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_ImmobilizzazioniAnno1;
        return Utilities.safeDivide(my_PatrimNettoAnno1, my_ImmobilizzazioniAnno1);
    });

    static getIndAutFinanzA2 = createSelector(revisione53State, (state) => {
        const my_PatrimNetto = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_PatrimNetto;
        const my_CapitInvest = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_CapitInvest;
        if (isNilOrEmpty(my_CapitInvest) || toNum(my_CapitInvest) === 0) return null;
        return Utilities.safeDivide(my_PatrimNetto, my_CapitInvest);
    });

    static getIndAutFinanzA1 = createSelector(revisione53State, (state) => {
        const my_PatrimNettoAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_PatrimNettoAnno1;
        const my_CapitInvestAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_CapitInvestAnno1;
        return Utilities.safeDivide(my_PatrimNettoAnno1, my_CapitInvestAnno1);
    });

    static getIndOnFinanzA2 = createSelector(revisione53State, (state) => {
        const my_RisultGest = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_RisultGest;
        const my_RicaviVendDep = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_RicaviVendDep;
        return Utilities.safeDivide(my_RisultGest, my_RicaviVendDep);
    });

    static getIndOnFinanzA1 = createSelector(revisione53State, (state) => {
        const my_RisultGestAnno1 = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_RisultGestAnno1;
        const my_RicaviVendAnno1Dep = state.revisione?.dati.my_Verbale.my_SezioneI__Rilevazione.my_RaggScopoSociale.my_RicaviVendAnno1Dep;
        return Utilities.safeDivide(my_RisultGestAnno1, my_RicaviVendAnno1Dep);
    });
}
